/** {@link https://docs.solanalabs.com/runtime/programs#system-program} */
export const systemProgramId = '11111111111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#config-program} */
export const configProgramId = 'Config1111111111111111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#stake-program} */
export const stakeProgramId = 'Stake11111111111111111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#vote-program} */
export const voteProgramId = 'Vote111111111111111111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#address-lookup-table-program} */
export const addressLookupTableProgramId =
  'AddressLookupTab1e1111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#bpf-loader} */
export const bpfLoaderProgramId = 'BPFLoaderUpgradeab1e11111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#ed25519-program} */
export const ed25519ProgramId = 'Ed25519SigVerify111111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/programs#secp256k1-program} */
export const secp256k1ProgramId = 'KeccakSecp256k11111111111111111111111111111'

/** {@link https://docs.solanalabs.com/runtime/zk-token-proof} */
export const zkTokenProofProgramId =
  'ZkTokenProof1111111111111111111111111111111'

/** {@link https://github.com/solana-labs/solana-program-library/blob/master/token/program/program-id.md} */
export const tokenProgramId = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA'

/** {@link https://github.com/solana-labs/solana-program-library/blob/master/token/program-2022/program-id.md} */
export const token2022ProgramId = 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb'

/** {@link https://solana.com/ja/developers/cookbook/tokens/manage-wrapped-sol} */
export const wrappedSolTokenMintId =
  'So11111111111111111111111111111111111111112'

/** {@link https://docs.solana.com/developing/programming-model/accounts#sol-token-account} */
export const nativeTokenDecimals = 9

// import { Connection } from "@solana/web3.js"
// import { AccountLayout } from "@solana/spl-token"
// TokenAccount 構成サイズが 165
// const size = AccountLayout.span // 165
// const connection = new Connection("https://api.mainnet-beta.solana.com")
// const rent = await connection.getMinimumBalanceForRentExemption(size)
// console.log(rent) // 2039280
// 少なくとも tokenProgramId, token2022ProgramId での create account や close account ではこの値
/** {@link https://www.helius.dev/docs/laserstream/guides/account-subscription} */
export const tokenAccountRentExemptAmount = 2039280
